import type { CreateRouterRequest, RouterEntity } from "../../types/router";
import type { AdminRouterRepository } from "../../repositories/admin/admin-router-repository";
import { AppError } from "../../../shared/utils/error-handler";

export class AdminRouterUseCase {
  constructor(private adminRouterRepository: AdminRouterRepository) {}

  async createRouter(companyId: number, request: CreateRouterRequest): Promise<void> {
    try {
      return await this.adminRouterRepository.createRouter(companyId, request);
    } catch (error) {
      throw new AppError(
        String(error) || "라우터 생성에 실패하였습니다.",
        "ROUTER_CREATE_FAILED",
        error,
      );
    }
  }

  async getRouters(companyId: number): Promise<RouterEntity[]> {
    try {
      return await this.adminRouterRepository.getRouters(companyId);
    } catch (error) {
      throw new AppError(
        String(error) || "라우터를 가져오지 못했습니다.",
        "ROUTERS_GET_FAILED",
        error,
      );
    }
  }
}